module.exports = __webpack_public_path__ + "img/inactive-13.211ab704.svg";